export const BookingTypeIds = {
  SP: 1,
  FP: 2,
  DP: 3,
  TICKET: 4,
  VS: 5,
  MO: 6,
  VM: 7,
  OTA: 8,
  PW: 9,
  MW: 10,
  OTHER: 11,
  POINT: 12,
  TRIAL: 13
}

export function canUseTvp (bookingTypeId) {
  return [
    BookingTypeIds.VS,
    BookingTypeIds.MO
  ].includes(bookingTypeId)
}
